import React from "react";
import { Chip, MenuItem, Select, useTheme } from "@mui/material";
import { formatSpeakerLabel, getSpeakerColorByLabel } from "./speakerColors";

interface EntrySpeakerSelectProps {
  value: string;
  speakers: string[];
  onChange: (label: string) => void;
  disabled?: boolean;
}

/** Speaker chip that opens a dropdown of the known speakers to reassign an entry. */
export const EntrySpeakerSelect: React.FC<EntrySpeakerSelectProps> = ({
  value,
  speakers,
  onChange,
  disabled = false,
}) => {
  const theme = useTheme();

  // The current value may not be in the list yet (legacy label) — include it.
  const options = speakers.includes(value) ? speakers : [value, ...speakers];

  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      variant="standard"
      disableUnderline
      renderValue={(label) => {
        const c = getSpeakerColorByLabel(label, speakers, theme.palette.mode);
        return (
          <Chip
            label={formatSpeakerLabel(label)}
            size="small"
            sx={{
              backgroundColor: c.soft,
              color: c.text,
              border: `1px solid ${c.border}`,
              fontWeight: 500,
              fontSize: "0.75rem",
              height: 22,
              cursor: disabled ? "default" : "pointer",
            }}
          />
        );
      }}
      sx={{
        // Reserve room for the dropdown caret so it doesn't overlap the chip.
        "& .MuiSelect-select": {
          py: 0,
          pl: 0,
          pr: disabled ? "0 !important" : "22px !important",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiSelect-icon": { display: disabled ? "none" : undefined },
      }}
    >
      {options.map((label) => {
        const c = getSpeakerColorByLabel(label, speakers, theme.palette.mode);
        return (
          <MenuItem key={label} value={label}>
            <Chip
              label={formatSpeakerLabel(label)}
              size="small"
              sx={{
                backgroundColor: c.soft,
                color: c.text,
                border: `1px solid ${c.border}`,
                fontWeight: 500,
                fontSize: "0.75rem",
                height: 22,
              }}
            />
          </MenuItem>
        );
      })}
    </Select>
  );
};
